module.exports = __webpack_public_path__ + "static/media/dec-tutorial-dl-back.74a8afd9.gif";